import { Descendant } from 'slate';
import { DocumentTranscriptParagraphV1 } from '@utils/types/editors/transcripts/transcript.ts';

export const currentParagraphIsSeeking = (
  paragraph: Descendant & DocumentTranscriptParagraphV1,
  currentTime: number
): boolean => {
  const seekingValueInSec = currentTime ? currentTime * 1000 : null;
  if (!seekingValueInSec || !paragraph.start || !paragraph.stop) return false;
  return (
    seekingValueInSec >= paragraph.start && seekingValueInSec <= paragraph.stop
  );
};
